import api, { toUserError } from './api'
import {
  clearSession,
  getCurrentUser,
  getStoredSession,
  getToken,
  isRemembered,
  writeSession,
} from './authStorage'

export async function login({ username, password, remember }) {
  try {
    const { data } = await api.post('/auth/login', {
      username: String(username || '').trim(),
      password,
    })
    const payload = data?.data || {}
    const user = payload.user
    const token = payload.token
    if (!user || !token) {
      throw new Error('로그인 응답이 올바르지 않습니다.')
    }
    writeSession(user, token, Boolean(remember))
    return {
      user,
      token,
      tokenType: payload.tokenType,
      expiresIn: payload.expiresIn,
      expiresAt: payload.expiresAt,
    }
  } catch (error) {
    throw toUserError(error)
  }
}

export async function fetchCurrentUser() {
  const { data } = await api.get('/auth/me')
  return data?.data?.user || null
}

export async function refreshCurrentUser() {
  const session = getStoredSession()
  if (!session?.token) return null
  const user = await fetchCurrentUser()
  if (!user) return null
  writeSession(user, session.token, isRemembered())
  return { user, token: session.token }
}

export async function restoreSession() {
  const session = getStoredSession()
  if (!session?.token) return null

  try {
    const user = await fetchCurrentUser()
    if (!user) {
      clearSession()
      return null
    }
    writeSession(user, session.token, isRemembered())
    return { user, token: session.token }
  } catch (error) {
    const status = error.response?.status
    if (status === 401 || status === 403) {
      clearSession()
      return null
    }
    return session
  }
}

export async function changePassword({ currentPassword, newPassword }) {
  try {
    const { data } = await api.put('/auth/password', {
      currentPassword,
      newPassword,
    })
    return data?.data?.user || null
  } catch (error) {
    throw toUserError(error)
  }
}

export function logout() {
  clearSession()
}

export { getCurrentUser, getStoredSession, getToken }
